import React, { memo } from 'react'

import { SectionItem } from '../sectionItem'

import styles from './myContact.module.scss'

function MyContact() {
  return (
    <SectionItem topic="Contact">
      <div className={styles.contact__item_wrapper}>
        <span className={styles.tag}>email</span>
        vitaya.jealwarakun@gmail.com
      </div>
      <div className={styles.contact__item_wrapper}>
        <span className={styles.tag}>github</span>
        github.com/Akiizu2
      </div>
      <div className={styles.contact__item_wrapper}>
        <span className={styles.tag}>Linkedin</span>
        linkedin.com/in/vitaya-jealwarakun
      </div>
      <div className={styles.contact__item_wrapper}>
        <span className={styles.tag}>Medium</span>
        medium.com/@vitaya.jealwarakun
      </div>
    </SectionItem>
  )
}

export default memo(MyContact)
